var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"stamp",style:(("padding: " + _vm.stampPadding))},[_c('div',{staticClass:"text-sm font-semibold no-wrap"},[_vm._v(_vm._s(_vm.stampNumber))])])}
var staticRenderFns = []

export { render, staticRenderFns }